import { MICROSOFTAD } from "../../../redux/constants/constants";
import {
  CLEAR_SYS_GUARD_ALERT_INFO_DATA,
  SET_SELECTED_DATASOURCE_IDS,
  SET_EDITING_DATASOURCE_ID,
  SET_SYS_FROM_TIME_STAMP,
  SET_SYS_GUARD_CITY_DATA,
  SET_SYS_GUARD_DATASOURCE,
  SET_ALL_SYS_GUARD_DATASOURCES,
  SET_SYS_GUARD_DISTINCT_LOCATIONS,
  SET_SYS_GUARD_HEADER_DATA,
  SET_SYS_GUARD_PAGE_LOADER,
  SET_SYS_GUARD_POPUP_DATA,
  SET_SYS_GUARD_POPUP_TOTAL_ELEMENTS,
  SET_SYS_GUARD_SIDE_POPUP_DATA,
  SET_SYS_GUARD_TABLE_DATA,
  SET_SYS_TO_TIME_STAMP,
  SET_TOTAL_ELEMENTS,
  SET_SYS_GUARD_ALERT_INFO_DATA,
  SET_INCOGNITO,
  CLEAR_SYS_GUARD_POPUP_DATA,
  CLEAR_SYS_GUARD_TABLE_DATA,
  SET_EXPANDED_USERS_DASHBOARD_DATA,
  SET_SYS_GUARD_ALERT_COMMENT,
  DISPLAY_SYS_GUARD_ALERT_COMMENT,
  SET_SYS_GUARD_ALERT_STATUS,
  OPEN_SYS_GUARD_SNACKBAR,
  SET_REPORT_INCIDENT_DETAILS,
  SET_SYS_GUARD_APPLICATION_NAMES,
  SET_SYS_GUARD_SELECTED_APPLICATIONS,
  SET_SYS_GUARD_SELECTED_COUNTRIES,
  SET_SYS_GUARD_COUNTRY_NAMES,
  SET_SYS_GUARD_THREAT_PROBABILITIES,
  SET_UNIQUE_USER_LIST,
  SET_SELECTED_USER,
  SET_SELECTED_MFA,
  SET_SELECTED_RISK_FACTOR,
  CLEAR_SYS_GUARD_FILTERS,
  SET_SYS_GUARD_TABLE_LOADER,
  SET_CHATBOT_LOADER,
  SET_CHATBOT_RESPONSE,
} from "../sysGuardConstants";

const initialState = {
  sysGuardDataSource: {},
  selectedDatasourceID: [],
  editingDatasourceID: null,
  loader: false,
  sysGuardTableLoader: false,
  fromTimeStamp: null,
  toTimeStamp: null,
  sysGuardTableData: null,
  totalElements: 0,
  sysGuardHeaderData: null,
  sysGuardUsersExpandedData: null,
  sysGuardPopupData: null,
  popupTotalElements: 0,
  sidePopupData: null,
  distinctLocations: null,
  cities: [],
  mapCenter: null,
  alertInfoData: null,
  incognito: true,
  displayAlertComment: false,
  alertComment: null,
  alertStatus: null,
  openSysGuardSnackBar : false,
  reportIncidentData: [],
  sysGuardApplicationNames: [],
  sysGuardSelectedApplications: [],
  sysGuardCountryNames: [],
  sysGuardSelectedCountryNames: [],
  sysGuardThreatProbabilityList: ["HIGH", "MEDIUM", "LOW"],
  sysGuardSelectedThreatProbabilities: [],
  sysGuardUniqueUserList: [],
  sysGuardSelectedUserName: [],
  sysGuardMFAList: ["YES", "NO"],
  sysGuardSelectedMFAList: [],
  sysGuardRiskFactorList: ["High", "Medium", "Low", "No Risk"],
  sysGuardSelectedRiskFactorList: [],
  chatbotResponse: [],
  chatbotLoader: false,
};

export const SysGuardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SYS_GUARD_DATASOURCE: {
      return {
        ...state,
        sysGuardDataSource: {
          ...state.sysGuardDataSource,
          [action.source]: action.payload, // Store by source (legacy support)
        }
    }
  }
    case SET_ALL_SYS_GUARD_DATASOURCES: {
      const dataSourcesById = {};
      const datasourceIds = [];
      action.payload.forEach(dataSource => {
        dataSourcesById[dataSource.id] = dataSource;
        datasourceIds.push(dataSource.id);
      });
      return {
        ...state,
        sysGuardDataSource: dataSourcesById,
        selectedDatasourceID: datasourceIds,
      };
    }
    case SET_SELECTED_DATASOURCE_IDS: {
      return {
        ...state,
        selectedDatasourceID: action.payload,
      };
    }
    case SET_EDITING_DATASOURCE_ID: {
      return {
        ...state,
        editingDatasourceID: action.payload,
      };
    }
    case SET_SYS_GUARD_PAGE_LOADER: {
      return {
        ...state,
        loader: action.payload,
      };
    }
    case SET_SYS_FROM_TIME_STAMP: {
      return {
        ...state,
        fromTimeStamp: action.payload,
      };
    }
    case SET_SYS_TO_TIME_STAMP: {
      return {
        ...state,
        toTimeStamp: action.payload,
      };
    }
    case SET_SYS_GUARD_TABLE_DATA: {
      return {
        ...state,
        sysGuardTableData: action.payload,
      };
    }
    case SET_TOTAL_ELEMENTS: {
      return {
        ...state,
        totalElements: action.payload,
      };
    }
    case SET_SYS_GUARD_HEADER_DATA: {
      return {
        ...state,
        sysGuardHeaderData: action.payload,
      };
    }
    case SET_SYS_GUARD_POPUP_DATA: {
      return {
        ...state,
        sysGuardPopupData: action.payload,
      };
    }
    case SET_SYS_GUARD_POPUP_TOTAL_ELEMENTS: {
      return {
        ...state,
        popupTotalElements: action.payload,
      };
    }
    case SET_SYS_GUARD_SIDE_POPUP_DATA: {
      return {
        ...state,
        sidePopupData: action.payload,
      };
    }
    case SET_SYS_GUARD_DISTINCT_LOCATIONS: {
      return {
        ...state,
        distinctLocations: action.payload,
      };
    }
    case SET_SYS_GUARD_CITY_DATA: {
      return {
        ...state,
        cities: action.payload.cities,
        mapCenter: action.payload.mapCenter,
      };
    }
    case SET_SYS_GUARD_ALERT_INFO_DATA: {
      return {
        ...state,
        alertInfoData: action.payload
      }
    }
    case SET_SYS_GUARD_SELECTED_APPLICATIONS: {
      return {
        ...state,
        sysGuardSelectedApplications: action.payload
      }
    }
    case SET_SYS_GUARD_SELECTED_COUNTRIES: {
      return {
        ...state,
        sysGuardSelectedCountryNames: action.payload
      }
    }
    case SET_SYS_GUARD_THREAT_PROBABILITIES: {
      return {
        ...state,
        sysGuardSelectedThreatProbabilities: action.payload
      }
    }
    case SET_INCOGNITO: {
      return {
        ...state,
        incognito: action.payload
      }
    }
    case SET_EXPANDED_USERS_DASHBOARD_DATA: {
      return {
        ...state,
        sysGuardUsersExpandedData: action.payload
      }
    }
    case SET_SYS_GUARD_ALERT_COMMENT: {
      return {
        ...state,
        alertComment: action.payload
      }
    }
    case DISPLAY_SYS_GUARD_ALERT_COMMENT: {
      return {
        ...state,
        displayAlertComment: action.payload
      }
    }
    case SET_SYS_GUARD_ALERT_STATUS: {
      return {
        ...state,
        alertStatus: action.payload
      }
    }
    case SET_REPORT_INCIDENT_DETAILS: {
      return {
        ...state,
        reportIncidentData: action.payload
      }
    }
    case SET_UNIQUE_USER_LIST: {
      return {
        ...state,
        sysGuardUniqueUserList: action.payload
      }
    }
    case SET_SELECTED_USER: {
      return {
        ...state,
        sysGuardSelectedUserName: action.payload
      }
    }
    case SET_SELECTED_MFA: {
      return {
        ...state,
        sysGuardSelectedMFAList: action.payload
      }
    }
    case SET_SELECTED_RISK_FACTOR: {
      return {
        ...state,
        sysGuardSelectedRiskFactorList: action.payload
      }
    }
    case OPEN_SYS_GUARD_SNACKBAR: {
      return {
        ...state,
        openSysGuardSnackBar: action.payload
      }
    }
    case SET_SYS_GUARD_APPLICATION_NAMES: {
      return {
        ...state,
        sysGuardApplicationNames: action.payload
      }
    }
    case SET_SYS_GUARD_COUNTRY_NAMES: {
      return {
        ...state,
        sysGuardCountryNames: action.payload
      }
    }
    case SET_SYS_GUARD_TABLE_LOADER: {
      return {
        ...state,
        sysGuardTableLoader: action.payload
      }
    }
    case SET_CHATBOT_RESPONSE: {
      return {
        ...state,
        chatbotResponse: action.payload
      };
    }
    case SET_CHATBOT_LOADER: {
      return {
        ...state,
        chatbotLoader: action.payload
      };
    }
    case CLEAR_SYS_GUARD_ALERT_INFO_DATA: {
      return {
        ...state,
        alertInfoData: null,
        reportIncidentData: null,
      }
    }
    case CLEAR_SYS_GUARD_TABLE_DATA: {
      return {
        ...state,
        sysGuardTableData: null
      }
    }
    case CLEAR_SYS_GUARD_FILTERS: {
      return {
        ...state,
        sysGuardSelectedApplications: [],
        sysGuardSelectedCountryNames: [],
        sysGuardSelectedThreatProbabilities: [],
        sysGuardSelectedUserName: [],
        sysGuardSelectedMFAList: [],
        sysGuardSelectedRiskFactorList: [],
      }
    }
    case CLEAR_SYS_GUARD_POPUP_DATA: {
      return {
        ...state,
        sysGuardPopupData: null,
      }
    }
    default:
      return state;
  }
};
